import { render, staticRenderFns } from "./X1Remote.vue?vue&type=template&id=31c2c21b&scoped=true"
import script from "./X1Remote.vue?vue&type=script&lang=js"
export * from "./X1Remote.vue?vue&type=script&lang=js"
import style0 from "./X1Remote.vue?vue&type=style&index=0&id=31c2c21b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../deps/0/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c2c21b",
  null
  
)

export default component.exports